module.exports = __webpack_public_path__ + "img/lottery.61beac22.png";